<template>
    <div :class="{
            'rounded-full': !!round,
            'shadow-xl': !flat && !border,
            'w-full ': !width,
            ['bg-'+color]: !!color,
            'text-white': dark,
            'p-4': !noPadding,
            ['border-'+borderColor]: !!border,
            ['overflow-'+overflow]: !!overflow,
            'h-full': !height

         }"
         :style="{
            width: !!width ? parse(width) : '100%',
            height: !!height ? parse(height) : '100%',
            'border-width': !!border ? parse(border) : '',
            'border-radius': !tile && !round ? '20px' : ''
         }"
         class="overflow-auto"
         @click="$emit('click')"
    >
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: "Card",
        props: {
            flat: {type: Boolean, default: false},
            width: {type: [Number, String, null], default: null},
            height: {type: [Number, String, null], default: null},
            tile: {type: Boolean, default: false},
            color: {type: String, default: 'white'},
            round: {type: Boolean, default: false},
            dark: {type: Boolean, default: false},
            noPadding: {type: Boolean, default: false},
            border: {type: [String, Number, null], default: null},
            borderColor: {type: [String, null], default: null},
            overflow: {type: String, default: 'auto'}
        },
        methods: {
            parse(value) {
                return value.toString().includes('%') ? value : (value.replace('px', '') + 'px');
            }
        }
    }
</script>

<style scoped>

</style>